<script lang="ts">
    import {onMount} from "svelte";
    import {getProfile} from 'src/components/cabinet/#services/getUserProfile'
    import Modal from 'src/components/#common/modal/Modal.svelte'
    import {banUser, unbanUser} from 'src/components/cabinet/#services/banUnbanUser'
    import {doShow as showAlert} from 'src/components/#common/alert/store'
    import {getAllMemberships, setMembership} from 'src/components/cabinet/#services/memberships'
    import {increaseLisBalance, decreaseLisBalance} from 'src/components/cabinet/#services/balance'
    import {myRole} from 'src/components/#common/myRole'
    import {resetGameProgress} from 'src/components/cabinet/#services/gameProgress'
    import {suspiciousToggle} from 'src/components/cabinet/#services/suspiciousUser'
    import { updateUserGameProgress } from "src/components/cabinet/#services/updateUserGameProgress";
    import {accrualNft} from 'src/components/cabinet/#services/nftRetrodrop'
    import {fixRollback} from 'src/components/cabinet/#services/userProgres'
    import {confirmedToggle} from 'src/components/cabinet/#services/user'

    export let userId

    let mounted = false
    let membershipSaved = false
    let banReason = ''
    let amount
    let currency = 'LIS'
    let updateBalanceSending = false
    let banModalOpen = false
    let increaseLisModalOpen = false
    let decreaseLisModalOpen = false
    let membershipModalOpen = false
    let resetProgressModalOpen = false
    let updateUserProgressGame = 3
    let updateUserProgressLevel = null
    let updateUserProgressMaxUnitLevel = null
    let updateUserProgressMapLevel = null
    let increaseDecreaseReason = ''
    let resetProgressGame = 3
    let banCheckbox
    let suspiciousCheckbox
    let confirmedCheckbox
    let accrualNftCount
    let unitLevel
    let fixRollbackGame
    let newMembership = {
        userId,
        days: '',
        appId: 3,
    }
    let profilePromise

    $:profilePromise = getProfile.request({ data: { userId } })

    $: if (!banCheckbox && $getProfile.hasValue) {
        banCheckbox = $getProfile.value && JSON.parse(JSON.stringify($getProfile.value.isBanned))
        suspiciousCheckbox = $getProfile.value && JSON.parse(JSON.stringify($getProfile.value.suspicious))
        confirmedCheckbox = $getProfile.value && JSON.parse(JSON.stringify($getProfile.value.isConfirmed))
    }

    getAllMemberships.send()

    function banChangeHandler() {
        if (banCheckbox === true) {
            unbanUserHandler()
        } else {
            banModalOpen = true
        }
    }

    async function suspiciousChangeHandler() {
        try {
            suspiciousCheckbox = !suspiciousCheckbox

            await suspiciousToggle.request({data: {
                userId,
                isSuspicious: suspiciousCheckbox
            }})

            if (suspiciousCheckbox) {
                showAlert.set({
                    status: 'success',
                    text: 'The user became a suspicious'
                })
            } else {
                showAlert.set({
                    status: 'success',
                    text: 'The user is no longer suspicious'
                })
            }

            getProfile.reset()
        } catch (err) {
            if (err.message) {
                showAlert.set({
                    status: 'error',
                    text: err.message
                })
            } else {
                showAlert.set({
                    status: 'error',
                    text: 'An Error Occurred, Please Try Again Later'
                })
            }
        }
    }

    async function confirmedChangeHandler() {
        try {
            confirmedCheckbox = !confirmedCheckbox

            await confirmedToggle.request({data: {
                userId,
                isConfirmed: confirmedCheckbox
            }})

            if (confirmedCheckbox) {
                showAlert.set({
                    status: 'success',
                    text: 'The user became a confirmed'
                })
            } else {
                showAlert.set({
                    status: 'success',
                    text: 'The user is no longer confirmed'
                })
            }

            getProfile.reset()
        } catch (err) {
            if (err.message) {
                showAlert.set({
                    status: 'error',
                    text: err.message
                })
            } else {
                showAlert.set({
                    status: 'error',
                    text: 'An Error Occurred, Please Try Again Later'
                })
            }
        }
    }

    async function banUserHandler() {
        try {
            await banUser.request({ data: {
                userId,
                reason: banReason
            }})

            banModalOpen = false
            banCheckbox = true

            showAlert.set({
                status: 'success',
                text: 'User successfully banned'
            })

            getProfile.reset()
        } catch (err) {
            banModalOpen = false

            if (err.message) {
                showAlert.set({
                    status: 'error',
                    text: err.message
                })
            } else {
                showAlert.set({
                    status: 'error',
                    text: 'An Error Occurred, Please Try Again Later'
                })
            }
        }
    }

    async function unbanUserHandler() {
        try {
            await unbanUser.request({data: {
                userId: userId
            }})

            showAlert.set({
                status: 'success',
                text: 'User successfully unbanned'
            })

            banCheckbox = false

            getProfile.reset()
        } catch (err) {
            if (err.message) {
                showAlert.set({
                    status: 'error',
                    text: err.message
                })
            } else {
                showAlert.set({
                    status: 'error',
                    text: 'An Error Occurred, Please Try Again Later'
                })
            }
        }
    }

    function beforeSetMembershipHandler() {
        membershipSaved = true
        if (newMembership.days !== '' && newMembership.days !== null) {
            membershipModalOpen = true
        }
    }

    async function setMembershipHandler() {
       try {
           if (newMembership.days !== '') {
               newMembership.appId = +newMembership.appId

               await setMembership.request({ data: newMembership })

               membershipModalOpen = false
               newMembership.days = ''
               membershipSaved = false

               showAlert.set({
                   status: 'success',
                   text: 'Membership successfully accrued!'
               })
           }
       } catch (err) {
           if (err.message?.includes('Action has gone on solution')) {
               membershipModalOpen = false
               newMembership.days = ''
               membershipSaved = false

               showAlert.set({
                   status: 'success',
                   text: 'Your action has been added to admin review'
               })
           } else if (err.message) {
               showAlert.set({
                   status: 'error',
                   text: err.message
               })
           } else {
               showAlert.set({
                   status: 'error',
                   text: 'An Error Occurred, Please Try Again Later'
               })
           }
       }
    }

    async function increaseLisBalanceHandler() {
        try {
            updateBalanceSending = true

            let extraDetail
            if (increaseDecreaseReason) {
                extraDetail = { "comment": increaseDecreaseReason }
            }

            await increaseLisBalance.request({ data: {
                "amount": amount.toString(),
                "currency": currency,
                "userId": userId,
                "creator": "admin",
                "txId": getTxId(userId),
                "reason": "adminManualFixBalance",
                extraDetail
            }})

            amount = ''
            increaseDecreaseReason = ''

            showAlert.set({
                status: 'success',
                text: 'LIS on the balance has been successfully increased'
            })
        } catch (err) {
            if (err.message?.includes('Action has gone on solution')) {
                amount = ''
                showAlert.set({
                    status: 'success',
                    text: 'Your action has been added to admin review'
                })
            } else if (err.message) {
                showAlert.set({
                    status: 'error',
                    text: err.message
                })
            } else {
                showAlert.set({
                    status: 'error',
                    text: 'An Error Occurred, Please Try Again Later'
                })
            }
        } finally {
            updateBalanceSending = false
            increaseLisModalOpen = false
        }
    }

    async function decreaseLisBalanceHandler() {
        try {
            updateBalanceSending = true

            let extraDetail
            if (increaseDecreaseReason) {
                extraDetail = { "comment": increaseDecreaseReason }
            }

            await decreaseLisBalance.request({ data: {
                "amount": amount.toString(),
                "currency": currency,
                "userId": userId,
                "creator": "admin",
                "txId": getTxId(userId),
                "reason": "adminManualFixBalance",
                extraDetail
            }})

            amount = ''
            increaseDecreaseReason = ''

            showAlert.set({
                status: 'success',
                text: 'LIS on the balance has been successfully decreased'
            })
        } catch (err) {
            if (err.message?.includes('Action has gone on solution')) {
                amount = ''
                showAlert.set({
                    status: 'success',
                    text: 'Your action has been added to admin review'
                })
            } else if (err.message) {
                showAlert.set({
                    status: 'error',
                    text: err.message
                })
            } else {
                showAlert.set({
                    status: 'error',
                    text: 'An Error Occurred, Please Try Again Later'
                })
            }
        } finally {
            updateBalanceSending = false
            decreaseLisModalOpen = false
        }
    }

    function getTxId(userId) {
        let d = new Date()
        return d.getDate() +'_'+ (d.getMonth()+1) +'_'+ d.getFullYear() +'_'+ d.getHours() +'_'+ d.getMinutes() +'_'+ d.getSeconds() +'_'+ userId
    }

    async function resetGameProgressHandler() {
        try {
            await resetGameProgress.request({
                data: {
                    internalUserId: userId,
                    appId: resetProgressGame
                }
            })

            showAlert.set({
                status: 'success',
                text: 'Game progress successfully reset'
            })
        } catch (err) {
            if (err.message) {
                showAlert.set({
                    status: 'error',
                    text: err.message
                })
            } else {
                showAlert.set({
                    status: 'error',
                    text: 'An Error Occurred, Please Try Again Later'
                })
            }
        } finally {
            resetProgressModalOpen = false
        }
    }

    async function updateUserProgressHandler() {
        try {
            await updateUserGameProgress.request({
                data: {
                    userId,
                    appId: updateUserProgressGame,
                    level: updateUserProgressLevel || undefined,
                    maxUnitLevel: updateUserProgressMaxUnitLevel || undefined,
                    mapLevel: updateUserProgressMapLevel || undefined,
                }
            })

            showAlert.set({
                status: 'success',
                text: 'Progress was successfully updated.'
            })
        } catch (err) {
            if (err.message) {
                showAlert.set({
                    status: 'error',
                    text: err.message
                })
            } else {
                showAlert.set({
                    status: 'error',
                    text: 'An Error Occurred, Please Try Again Later'
                })
            }
        } finally {
            updateUserProgressLevel = null
            updateUserProgressMaxUnitLevel = null
            updateUserProgressMapLevel = null
        }
    }

    async function increaseNFT() {
        try {
            await accrualNft.request({ data: {
                type: 'lootbox',
                collection: 'meowgon',
                count: accrualNftCount,
                userId
            }})

            accrualNftCount = undefined

            showAlert.set({
                status: 'success',
                text: 'NFT successfully added!'
            })
        } catch (err) {
            if (err.message) {
                showAlert.set({
                    status: 'error',
                    text: err.message
                })
            } else {
                showAlert.set({
                    status: 'error',
                    text: 'An Error Occurred, Please Try Again Later'
                })
            }
        }
    }

    async function fixRollbackHandler() {
        try {
            await fixRollback.request({
                data: {
                    userId,
                    appId: fixRollbackGame,
                    unitLevel
                }
            })

            unitLevel = ''

            showAlert.set({
                status: 'success',
                text: 'Rollback was successfully fixed'
            })
        } catch (err) {
            if (err.message) {
                showAlert.set({
                    status: 'error',
                    text: err.message
                })
            } else {
                showAlert.set({
                    status: 'error',
                    text: 'An Error Occurred, Please Try Again Later'
                })
            }
        }
    }

    onMount(() => {
        mounted = true
    })

    $: if (mounted) {
        if ($getProfile.hasValue) {
            banCheckbox = $getProfile.value.isBanned
            suspiciousCheckbox = $getProfile.value.suspicious
        }
    }
</script>

<div class="actions-list">
    {#if $myRole.hasValue && $myRole?.value?.methods?.includes("updateBalance")}
        <div class="form-group">
            <label>LIS Balance</label>
            <div class="input-group mb-3 filter">
                <input type="text" class="form-control" placeholder="Enter value..." bind:value={amount}>
                <select class="form-select currency-list" bind:value={currency}>
                    <option value="LIS">LIS</option>
                    <option value="PLIS">PLIS</option>
                    <option value="BLIS">BLIS</option>
                    <option value="WLIS">WLIS</option>
                    <option value="PWLIS">PWLIS</option>
                    <option value="TLIS">TLIS</option>
                    <option value="USDT">USDT</option>
                    <option value="NEAR">NEAR</option>
                    <option value="MATIC">MATIC</option>
                    <option value="DOGE">DOGE</option>
                    <option value="WDOGE">WDOGE</option>
                    <option value="PDOGE">PDOGE</option>
                    <option value="PWDOGE">PWDOGE</option>
                    <option value="BDOGE">BDOGE</option>
                    <option value="PEPE">PEPE</option>
                    <option value="WPEPE">WPEPE</option>
                    <option value="PPEPE">PPEPE</option>
                    <option value="PWPEPE">PWPEPE</option>
                    <option value="BPEPE">BPEPE</option>
                </select>
                <button type="submit" class="btn btn-success" on:click={() => { if (amount > 0) increaseLisModalOpen = true }}>Increase</button>
                <button type="submit" class="btn btn-danger" on:click={() => { if (amount > 0) decreaseLisModalOpen = true }}>Decrease</button>
            </div>
            <Modal bind:visible={increaseLisModalOpen} size="sm">
                <svelte:fragment slot="content">
                    <div class="modal-custom__title">Increase {currency}</div>
                    <div class="modal-custom__text">
                        Do you really want to increase user balance by <strong>{amount}</strong> {currency}?<br>
                        <div><label>Reason:</label></div>
                        <textarea class="form-control" bind:value={increaseDecreaseReason}></textarea>
                    </div>
                    <div class="modal-custom__footer">
                        <button class="btn btn-cancel" on:click={() => { increaseLisModalOpen = false }}>Cancel</button>
                        <button class="btn btn-primary" class:loading={updateBalanceSending} on:click={increaseLisBalanceHandler} disabled={updateBalanceSending}>Yes</button>
                    </div>
                </svelte:fragment>
            </Modal>
            <Modal bind:visible={decreaseLisModalOpen} size="sm">
                <svelte:fragment slot="content">
                    <div class="modal-custom__title">Decrease {currency}</div>
                    <div class="modal-custom__text">
                        Do you really want to decrease user balance by <strong>-{amount}</strong> {currency}?<br>
                        <div><label>Reason:</label></div>
                        <textarea class="form-control" bind:value={increaseDecreaseReason}></textarea>
                    </div>
                    <div class="modal-custom__footer">
                        <button class="btn btn-cancel" on:click={() => { decreaseLisModalOpen = false }}>Cancel</button>
                        <button class="btn btn-primary" class:loading={updateBalanceSending} on:click={decreaseLisBalanceHandler} disabled={updateBalanceSending}>Yes</button>
                    </div>
                </svelte:fragment>
            </Modal>
        </div>
        <hr>
    {/if}
    {#if $myRole.hasValue && $myRole?.value?.name === 'SuperAdmin'}
        <div class="form-group">
            <label>Accrual NFT</label>
            <div class="input-group mb-3">
                <input type="number" class="form-control" bind:value={accrualNftCount} placeholder="Enter count...">
                <button type="submit" class="btn btn-primary" on:click={increaseNFT}>Accrual NFT</button>
            </div>
        </div>
    {/if}
    {#if $myRole.hasValue && $myRole?.value?.methods?.includes("fixRollback")}
        <div class="form-group">
            <label>Progress rollback</label>
            <div class="input-group mb-3">
                <input type="number" class="form-control" bind:value={unitLevel} placeholder="Enter level...">
                <select class="form-select" bind:value={fixRollbackGame}>
                    <option value={3}>Crypto Cats</option>
                    <option value={5}>Crypto Dragons (Android)</option>
                    <option value={6}>Crypto Dragons (IOS)</option>
                    <option value={7}>Crypto Fox</option>
                    <option value={11}>Crypto DOGE</option>
                    <option value={13}>Elon Game</option>
                    <option value={15}>Crypto Pepe</option>
                </select>
                <button type="submit" class="btn btn-primary" on:click={fixRollbackHandler}>Fix rollback</button>
            </div>
        </div>
    {/if}
    {#if $myRole.hasValue && $myRole?.value?.methods?.includes("setMembership")}
        <div class="form-group">
            <label>Membership</label>
            {#if $getAllMemberships.loading}
                <div>Loading...</div>
            {:else if $getAllMemberships.error || !$getAllMemberships.hasValue }
                <div>An error has occurred</div>
            {:else if $getAllMemberships.hasValue}
                <div class="input-group mb-3 filter">
                    <select class="form-select" bind:value={newMembership.membershipId}>
                        {#each $getAllMemberships.value as { membership, isAvailable, membershipId }}
                            {#if membership !== 'standard' && isAvailable}
                                <option value="{membershipId}">
                                    {membership.charAt(0).toUpperCase() + membership.slice(1)}
                                </option>
                            {/if}
                        {/each}
                    </select>
                    <select class="form-select" bind:value={newMembership.appId}>
                        <option value={3}>Crypto Cats</option>
                        <option value={5}>Crypto Dragons (Android)</option>
                        <option value={6}>Crypto Dragons (IOS)</option>
                        <option value={7}>Crypto Fox</option>
                        <option value={11}>Crypto DOGE</option>
                        <option value={13}>Elon Game</option>
                        <option value={15}>Crypto Pepe</option>
                    </select>
                    <input type="number" class="form-control" class:is-invalid={membershipSaved && (newMembership.days === '' || newMembership.days === null)}
                       bind:value={newMembership.days} placeholder="Enter days...">
                    <button type="submit" class="btn btn-primary" on:click={beforeSetMembershipHandler}>Set</button>
                    <Modal bind:visible={membershipModalOpen} size="sm">
                        <svelte:fragment slot="content">
                            <div class="modal-custom__title">Set membership</div>
                            <div class="modal-custom__text">Are you sure you want to give the user a new membership for <strong>{newMembership.days}</strong> days?</div>
                            <div class="modal-custom__footer">
                                <button class="btn btn-cancel" on:click={() => { membershipModalOpen = false }}>Cancel</button>
                                <button class="btn btn-primary" on:click={setMembershipHandler}>Yes</button>
                            </div>
                        </svelte:fragment>
                    </Modal>
                </div>
            {/if}
        </div>
        <hr>
    {/if}
    {#if process.env.SHOW_BROWSER_LOG && $myRole.hasValue && $myRole?.value?.name === 'SuperAdmin'}
        <div class="form-group">
            <label>Reset game progress</label>
            <div class="input-group mb-3 filter">
                <select class="form-select" bind:value={resetProgressGame}>
                    <option value={3}>Crypto Cats</option>
                    <option value={5}>Crypto Dragons (Android)</option>
                    <option value={6}>Crypto Dragons (IOS)</option>
                    <option value={7}>Crypto Fox</option>
                    <option value={11}>Crypto DOGE</option>
                    <option value={13}>Elon Game</option>
                    <option value={15}>Crypto Pepe</option>
                </select>
                <button class="btn btn-danger" on:click={() => { resetProgressModalOpen = true }}>Reset progress</button>
            </div>
            <Modal bind:visible={resetProgressModalOpen} size="sm">
                <svelte:fragment slot="content">
                    <div class="modal-custom__title">Reset progress</div>
                    <div class="modal-custom__text">
                        <p>Do you really want to reset game progress?</p>
                    </div>
                    <div class="modal-custom__footer">
                        <button class="btn btn-cancel" on:click={() => { resetProgressModalOpen = false }}>Cancel</button>
                        <button class="btn btn-primary" on:click={resetGameProgressHandler}>Reset</button>
                    </div>
                </svelte:fragment>
            </Modal>
        </div>
        <hr>
    {/if}
    {#if process.env.SHOW_BROWSER_LOG && $myRole.hasValue && $myRole?.value?.name === 'SuperAdmin'}
        <div class="form-group">
            <label>Update user progress</label>
            <div class="input-group mb-3 filter">
                <select class="form-select" bind:value={fixRollbackGame}>
                    <option value={3}>Crypto Cats</option>
                    <option value={5}>Crypto Dragons (Android)</option>
                    <option value={6}>Crypto Dragons (IOS)</option>
                    <option value={7}>Crypto Fox</option>
                    <option value={11}>Crypto DOGE</option>
                    <option value={13}>Elon Game</option>
                    <option value={15}>Crypto Pepe</option>
                </select>
                <input type="number" class="form-control" placeholder="Level" bind:value={updateUserProgressLevel}>
                <input type="number" class="form-control" placeholder="Max unit level" bind:value={updateUserProgressMaxUnitLevel}>
                <input type="number" class="form-control" placeholder="Map level" bind:value={updateUserProgressMapLevel}>
                <button class="btn btn-danger" on:click={updateUserProgressHandler}>Submit</button>
            </div>
        </div>
        <hr>
    {/if}
    {#if $myRole.hasValue && $myRole?.value?.methods?.includes("ban")}
        {#await profilePromise}
            Loading...
        {:then profile}
            <div class="form-group">
                <div class="input-group mb-3 filter">
                    <div class="form-check">
                        <label class="form-check-label">
                            <input class="form-check-input" type="checkbox" bind:checked={banCheckbox} on:click|preventDefault={banChangeHandler}>
                            User banned
                        </label>
                    </div>
                </div>
                <Modal bind:visible={banModalOpen} size="sm">
                    <svelte:fragment slot="content">
                        <div class="modal-custom__title">Ban user</div>
                        <div class="modal-custom__text">
                            <p>Why do you want to ban a user?</p><textarea bind:value={banReason} class="form-control" placeholder="Reason..." autofocus></textarea>
                        </div>
                        <div class="modal-custom__footer">
                            <button class="btn btn-cancel" on:click={() => { banModalOpen = false }}>Cancel</button>
                            <button class="btn btn-primary" on:click={banUserHandler}>Ban</button>
                        </div>
                    </svelte:fragment>
                </Modal>
            </div>
        {:catch error}
            {error}
        {/await}
    {/if}
    {#await profilePromise}
        Loading...
    {:then profile}
        <div class="form-group">
            <div class="input-group mb-3 filter">
                <div class="form-check">
                    <label class="form-check-label">
                        <input class="form-check-input" type="checkbox" checked={suspiciousCheckbox} on:change|preventDefault={suspiciousChangeHandler}>
                        User suspicious
                    </label>
                </div>
            </div>
        </div>
        <div class="form-group">
            <div class="input-group mb-3 filter">
                <div class="form-check">
                    <label class="form-check-label">
                        <input class="form-check-input" type="checkbox" checked={confirmedCheckbox} on:change|preventDefault={confirmedChangeHandler}>
                        User confirmed
                    </label>
                </div>
            </div>
        </div>
    {:catch error}
        {error}
    {/await}
    <!--
    <hr>
    <div class="form-group">
        <label>Notification</label>
        <textarea class="form-control mb-3"></textarea>
        <button class="btn btn-primary">Send</button>
    </div>
    -->
</div>

<style>
    .actions-list {
        max-width: 600px;
    }

    .form-check * {
        cursor: pointer;
    }

    .modal-custom__text {
        white-space: initial;
    }

    .currency-list {
        max-width: 100px;
        min-width: 100px;
    }
</style>
